<template>
    <div class="article-container">
        <div class="basic-info">
            <div>
                <div class="head">
                    <img class="top" src="../../images/community/top.png" alt="" v-if="articleInfo.is_top">
                    <h3  @click="goArticleDetail(articleInfo)" class="question-name" v-if="articleInfo.afterHtmlTitle">
                        <p v-html="filterXSS(articleInfo.afterHtmlTitle)"></p>
                    </h3>
                    <h3  @click="goArticleDetail(articleInfo)" class="question-name" v-else>
                        {{articleInfo.title}}
                    </h3>
                </div>
                <ul class="tags">
                    <li v-for="(i,index) in articleInfo.tags" @click="tagSelector(i)" :key="index">
                        {{i.title}}
                    </li>
                </ul>
                <div class="question-desc" @click="goArticleDetail(articleInfo)">
                    <span v-html="articleInfo.descText"></span>
                </div>
            </div>
            <div style="display: none;" :id="`virtual-dom-${articleInfo.id}`" class="question-desc img-hook"  v-html="filterXSS(articleInfo.afterhtmlData)" ref="descHook"></div>
            <p class="question-img" v-if="articleInfo.imgSrc !== ''">
                <img :src="articleInfo.imgSrc" />
            </p>
        </div>
        <div class="comment-bottom-content">
            <div class="footer-list">
                <div class="answer-type" v-if="isSearch">文章</div>
                <p class="footer-item default">
                    <i class="smart-icon view-icon"></i>
                    <span>{{articleInfo.no_of_views | transformUnit}}<i class="text">阅读</i></span>
                </p>
                <el-tooltip
                    effect="dark"
                    :content="articleInfo.is_vote_up ? '取消点赞' : '点赞'"
                    placement="top">
                    <p :class="['footer-item', 'great', {'is-active': articleInfo.is_vote_up}]" @click="onVoteToggle(articleInfo)">
                        <i class="smart-icon like-icon"></i>
                        <span>{{articleInfo.no_of_vote_up}}<i class="text">赞</i></span>
                    </p>
                </el-tooltip>
                <p :class="['footer-item', 'comment', {'is-active': articleInfo.is_me_comment}]" @click="goArticleDetail(articleInfo, true)">
                    <i class="smart-icon comment-icon"></i>
                    <span>{{articleInfo.no_of_comment}}<i class="text">评论</i></span>
                </p>
                <el-tooltip
                    effect="dark"
                    :content="articleInfo.is_liked ? '取消收藏' : '收藏'"
                    placement="top">
                    <p :class="['footer-item', 'favorite', {'is-active': articleInfo.is_liked}]" @click="favoriteToggle(articleInfo)">
                        <i class="smart-icon collect-icon"></i>
                        <span>{{articleInfo.no_of_likes}}<i class="text">收藏</i></span>
                    </p>
                </el-tooltip>
            </div>
            <p class="topic-people">
                <el-popover
                    popper-class="user-card"
                    placement="top"
                    :open-delay="500"
                    width="400"
                    trigger="hover"
                    @show="$refs['card' +articleInfo.created_by.id].getUserInfo()">
                    <div style="text-align: right; margin: 0, padding: 0">
                        <user-card :ref="`card${articleInfo.created_by.id}`" :user-id="articleInfo.created_by.id"></user-card>
                    </div>
                    <div slot="reference" class="user-avatar" @click="visible = !visible">
                        <img class="create-user-logo"
                            src="../../images/personal_center/avatar_default.png"
                            v-if="articleInfo.created_by.user_logo.substr(0,1)=='?'" @click="goHomePage(articleInfo.created_by)">
                        <img class="create-user-logo" :src="articleInfo.created_by.user_logo" alt="" v-else @click="goHomePage(articleInfo.created_by)">
                        <span class="create-user-name" @click="goHomePage(articleInfo.created_by)" v-html="articleInfo.afterHtmlName"></span>
                    </div>
                </el-popover>
                <el-tooltip v-if="articleInfo.created_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                    <svg style="width: 20px; height: 20px" aria-hidden="true">
                        <use xlink:href="#icon-lanjingguanfang"></use>
                    </svg>
                </el-tooltip>
                <el-tooltip v-if="articleInfo.created_by.is_vip" effect="light" content="核心用户" placement="right">
                    <span class="icon-vipuser"></span>
                </el-tooltip>
                <span> 于 {{articleInfo.created_on}}</span>
            </p>
        </div>
    </div>
</template>

<script>
import userCard from '../common/userCard.vue'
export default {
    components: {
        userCard
    },
    props: {
        articleInfo: {
            type: Object,
            default: () => ({})
        },
        isLogin: {
            type: Boolean,
            default: false
        },
        isSearch: {
            type: Boolean,
            default: false
        },
        userId: {
            type: Number,
            default: 0
        }
    },
    filters: {
        transformUnit (val) {
            if (val > 10000) {
                let num = Math.floor( val / 1000 )
                const remainder = val % 1000
                if (remainder > 100) {
                    num += `.${Math.floor(remainder / 100)}`
                }
                return `${num}K`
            }
            return val
        }
    },
    methods: {
        goArticleDetail (item, isComment) {
            if (isComment) {
                localStorage.setItem('commentWrapper', true)
            }
            let routeData = this.$router.resolve({
                name: 'Question',
                params: {
                    wid: item.id
                },
                query: {
                    type: 'article'
                }
            })
            window.open(routeData.href, '_blank')
        },
        // 前往个人主页
        goHomePage (userInfo) {
            // 判断是否为自己或者他人
            const isMatch = this.userId === userInfo.user_id
            const path = isMatch ? '/s-mart/personal_center/' : `/s-mart/personal_center/user/${userInfo.user_id}`
            let routeData = this.$router.resolve({
                path
            })
            window.open(routeData.href, '_blank')
        },
        // 点击热门标签
        tagSelector (item) {
            this.$emit('tagSelector', item);
        },
        onVoteToggle (info) {
            this.$emit('onVoteToggle', info)
        },
        favoriteToggle (info) {
            this.$emit('favoriteToggle', info)
        }
    },
}
</script>

<style lang="scss" scoped>
    .article-container {
        .basic-info{
            display: flex;
            justify-content: space-between;

            .head{
                display: flex;
                align-items: flex-start;
                margin-bottom: 15px;
                .top {
                    width: 24px;
                    height: 24px;
                    margin-right: 7px;
                }
                .question-name{
                    word-break: break-all;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 21px;
                    color: #313238;
                    font-weight: bold;
                    transition: all 0.3s ease;
                    .mark-red{
                        color: #ff5858;
                    }
                    &:hover {
                        color: #3a84ff;
                    }
                }
            }
            .tags {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                >li {
                    cursor: pointer;
                    margin: 0 10px 10px 0;
                    padding: 2px 10px;
                    border-radius: 11px;
                    border: 1px solid #e3e8f2;
                    background: #fafafc;
                    font-size: 12px;
                    color: #888991;
                    text-align: center;
                    line-height: 16px;
                    &:hover {
                        background: #e1ecff;
                        color: #3a84ff;
                        border: 1px solid #3a84ff;
                    }
                }
            }
            .question-desc {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                cursor: pointer;
                word-break: break-all;
            }
            .question-img {
                flex-shrink: 0;
                margin-left: 19px;
                img {
                    width: auto;
                    height: auto;
                    max-height: 119px;
                    max-width: 190px;
                }
            }
        }
        .comment-bottom-content {
            margin-top: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #63656e;
            .footer-list {
                font-size: 0;
                display: flex;
                align-items: center;
                .answer-type {
                    position: relative;
                    width: 34px;
                    height: 20px;
                    border: 1px solid #b6d2ff;
                    border-radius: 2px;
                    font-size: 12px;
                    color: #3a84ff;
                    text-align: center;
                    line-height: 18px;
                    margin-right: 27px;
                    &::after {
                        content: '';
                        width: 4px;
                        height: 4px;
                        opacity: 1;
                        background: #979ba5;
                        border-radius: 50%;
                        position: absolute;
                        right: -14px;
                        top: 8px;
                    }
                }
                .footer-item {
                    display: flex;
                    align-items: center;
                    margin-right: 40px;
                    padding-left: 3px;
                    line-height: 14px;
                    font-size: 12px;
                    transition: all 0.3s ease;
                    .smart-icon {
                        height: 16px;
                        width: 16px;
                        margin-right: 6px;
                        position: relative;
                        z-index: 2;
                        &::before, &::after {
                            content: '';
                            height: 16px;
                            width: 16px;
                            position: absolute;
                            z-index: 1;
                            display: none;
                        }
                        &.view-icon {
                            background: url('../../images/community/eye-open.png');
                            background-size: 100% 100%;
                        }
                        &.comment-icon {
                            background: url('../../images/community/comment3.png');
                            background-size: 100% 100%;
                            &::before {
                                background: url('../../images/community/comment4.png');
                                background-size: 100% 100%;
                            }
                            &::after {
                                background: url('../../images/community/comment5.png');
                                background-size: 100% 100%;
                            }
                        }
                        &.like-icon {
                            background: url('../../images/community/great3.png');
                            background-size: 100% 100%;
                            &::before {
                                background: url('../../images/community/great4.png');
                                background-size: 100% 100%;
                            }
                            &::after {
                                background: url('../../images/community/great2.png');
                                background-size: 100% 100%;
                            }
                        }
                        &.collect-icon {
                            background: url('../../images/community/favorite3.png');
                            background-size: 100% 100%;
                            &::before {
                                background: url('../../images/community/favorite4.png');
                                background-size: 100% 100%;
                            }
                            &::after {
                                background: url('../../images/community/favorite2.png');
                                background-size: 100% 100%;
                            }
                        }
                    }
                    &:hover {
                        &:not(.default) {
                            cursor: pointer;
                            color: #3a84ff;
                        }
                        .smart-icon::before {
                            display: block;
                            z-index: 3;
                        }
                    }
                    &.is-active {
                        color: #3a84ff;
                        .smart-icon::after {
                            display: block;
                            z-index: 3;
                        }
                    }
                    .text {
                        margin-left: 2px;
                        font-style: initial;
                    }
                }
            }
            .topic-people {
                display: flex;
                align-items: center;
                font-size: 12px;
                line-height:19px;
                .create-user-logo {
                    height: 18px;
                    width: 18px;
                    border-radius: 50%;
                    cursor: pointer;
                    margin-right: 5px;
                }
                .create-user-name {
                    cursor: pointer;
                    margin-right: 2px;
                    &:hover {
                        color: #3a84ff;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// articleContainer.vue?739f2cf3